module.exports = __webpack_public_path__ + "img/vehicles.72ff8dfe.svg";